<script>
import programService from "@/services/program";
import { mapGetters } from "vuex";

export default {
  name: "ProgramSelect",
  props: {
    value: { type: String },
    readonly: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
  },

  data() {
    return {
      programs: [],
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters(["user"]),

    findProgramById() {
      const program = this.programs.find((elem) => elem._id === this.value);
      return program?.name || program?.title || "Sin datos";
    },
  },

  async created() {
    await this.getPrograms();
  },

  methods: {
    async getPrograms() {
      this.isLoading = true;
      try {
        const response = await programService.getAllPrograms();
        this.programs = Array.isArray(response)
          ? response
          : response.data || [];

        this.programs.forEach((program) => {
          this.$store.dispatch("addProgram", program);
        });
      } catch (error) {
        console.error("Error al cargar programas:", error);
        this.programs = [];
        this.$message.error("Error al cargar los programas");
      }
      this.isLoading = false;
    },

    onInput(value) {
      this.$emit("input", value);
      const selectedProgram = this.programs.find(
        (program) => program._id === value
      );
      if (selectedProgram) {
        this.$emit("program-selected", selectedProgram);
      }
    },
  },
};
</script>

<template lang="pug">
div
  el-select(
    v-if="!readonly"
    :value="value"
    @input="onInput"
    :loading="isLoading"
    :disabled="isDisabled"
    placeholder="Seleccionar programa"
  )
    el-option(
      v-for="program in programs"
      :key="program._id"
      :label="program.name || program.title"
      :value="program._id"
    )

  el-input(
    v-else
    :value="findProgramById"
    readonly
  )
</template>

<style scoped></style>
